require('./bootstrap');
require('./signature-pad');
import 'jquery-ui/ui/widget';
import 'jquery-ui/dist/jquery-ui';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/datepicker';
import 'bootstrap-table';
import 'bootstrap-table/dist/extensions/filter-control/bootstrap-table-filter-control';
import 'bootstrap-table/dist/extensions/custom-view/bootstrap-table-custom-view';
import 'bootstrap-table/dist/extensions/export/bootstrap-table-export';
import 'jquery-treegrid/js/jquery.treegrid';
import 'bootstrap-table/dist/extensions/mobile/bootstrap-table-mobile';
import 'bootstrap-table/dist/extensions/treegrid/bootstrap-table-treegrid';
import 'bootstrap-table/dist/extensions/print/bootstrap-table-print.min';
import './default-charts';
import './dialer.js';
import './gridstack.js';
import './dropzone.js';
import './tour.js';

$('.draggable').draggable({cancel: ".undraggable"});
$('.droppable').droppable();
$('.resizable').resizable();
$('.datepicker').datepicker();
$('.sortable').sortable({
    revert: true,
    placeholder: "highlight-sortable"
});

